export const getComputedCSSVariable = (variableName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(
    variableName
  );
};
